import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

import { VpDialogContent } from '../../components';
import { VpHookFormWrapper } from '../../wrappers';

import CreateCompilationForm from './CreateCompilationForm';
import { usePostVideoCompilationPage } from '../../../hooks';
import { withRouter } from 'react-router';

export const CreateCompilationDialog = withRouter(
  ({ history, onClose = () => {}, open = 'false' }) => {
    const {
      mutate: postVideoCompilationPage,
      isSuccess,
      data: createCompilationResponse
    } = usePostVideoCompilationPage();

    const onSubmit = (formData) => {
      const payload = {
        campaignId: formData?.campaignId,
        title: formData?.title,
        migrateVideos: !!formData?.migrateVideos,
        autoInclude: !!formData?.autoInclude
      };

      postVideoCompilationPage(payload);
    };

    useEffect(() => {
      if (isSuccess && createCompilationResponse?.pageLink) {
        history.push(`/compilation/${createCompilationResponse?.pageLink}`);
        onClose();
      }
    }, [createCompilationResponse]);

    return (
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={onClose}
        open={open}
        data-testid="create-video-compilation-modal"
      >
        <VpDialogContent disablePadding>
          <VpHookFormWrapper onSubmit={onSubmit} formData={{ mode: 'all' }}>
            <CreateCompilationForm onCancel={onClose} />
          </VpHookFormWrapper>
        </VpDialogContent>
      </Dialog>
    );
  }
);

CreateCompilationDialog.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool
};

export default CreateCompilationDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/CreateCompilationDialog/CreateCompilationDialog.jsx